import {
  Globe,
  Database,
  Bell,
  Shield,
  Calendar,
  Mail,
  Brain,
  TrendingUp,
  DollarSign
} from 'lucide-react';
import type {
  GeneralConfig,
  FirebaseConfig,
  GoogleConfig,
  EmailConfig,
  OpenAIConfig,
  ResendConfig,
  StorageConfig,
  GrafanaConfig,
  BudgetConfig,
  SettingsTab
} from './types';

export const DEFAULT_GENERAL_CONFIG: GeneralConfig = {
  companyName: 'Cero Ideas',
  supportEmail: 'contacto@ceroideas.es',
  systemTimezone: 'Europe/Madrid',
  defaultCurrency: 'EUR'
};

export const DEFAULT_FIREBASE_CONFIG: FirebaseConfig = {
  enabled: false,
  apiKey: '',
  authDomain: '',
  projectId: '',
  storageBucket: '',
  messagingSenderId: '',
  appId: '',
  vapidKey: ''
};

export const DEFAULT_GOOGLE_CONFIG: GoogleConfig = {
  enabled: false,
  clientId: '',
  clientSecret: '',
  redirectUri: 'http://localhost:5173/auth/google/callback'
};

export const DEFAULT_EMAIL_CONFIG: EmailConfig = {
  enabled: false,
  useInternalEmail: false,
  sendgridApiKey: '',
  smtpHost: '',
  smtpPort: 587,
  smtpSecure: true,
  smtpUser: '',
  smtpPassword: '',
  emailFromAddress: 'noreply@ceroideas.es',
  emailFromName: 'Cero Ideas CRM'
};

export const DEFAULT_OPENAI_CONFIG: OpenAIConfig = {
  enabled: false,
  apiKey: '',
  organizationId: '',
  model: 'gpt-4',
  maxTokens: 1000,
  temperature: 0.7,
  isConfigured: false,
  billingInfo: null,
  usageHistory: []
};

export const DEFAULT_RESEND_CONFIG: ResendConfig = {
  enabled: false,
  apiKey: '',
  fromEmail: 'noreply@ceroideas.es',
  fromName: 'Cero Ideas CRM',
  isConfigured: false
};

export const DEFAULT_STORAGE_CONFIG: StorageConfig = {
  serviceType: 'wasabi',
  endpoint: '',
  accessKey: '',
  secretKey: '',
  bucketName: '',
  region: '',
  isConfigured: false,
  lastBackup: null,
  backupFrequency: 'weekly'
};

export const DEFAULT_GRAFANA_CONFIG: GrafanaConfig = {
  enabled: false,
  url: '',
  apiKey: '',
  lokiUrl: '',
  dashboardId: '',
  isConfigured: false
};

export const DEFAULT_BUDGET_CONFIG: BudgetConfig = {
  apiUrl: '',
  apiKey: '',
  isActive: false,
  lastTestedAt: null,
  testStatus: 'never_tested',
  testMessage: ''
};

export const OPENAI_USAGE_HISTORY_LIMIT = 20;

export interface SettingsTabDefinition {
  id: SettingsTab;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
}

export const SETTINGS_TABS: SettingsTabDefinition[] = [
  { id: 'general', label: 'General', icon: Globe },
  { id: 'connections', label: 'Conexiones', icon: Database },
  { id: 'reminders', label: 'Recordatorios', icon: Bell },
  { id: 'firebase', label: 'Firebase', icon: Shield },
  { id: 'google', label: 'Google Calendar', icon: Calendar },
  { id: 'email', label: 'Email', icon: Mail },
  { id: 'openai', label: 'OpenAI', icon: Brain },
  { id: 'resend', label: 'Resend', icon: Mail },
  { id: 'storage', label: 'Almacenamiento', icon: Database },
  { id: 'monitoring', label: 'Monitoreo (Grafana)', icon: TrendingUp },
  { id: 'budget', label: 'Presupuestos', icon: DollarSign }
];
